var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-form-element',[_c('p-select',_vm._g(_vm._b({attrs:{"value":_vm.value,"items":_vm.items},on:{"input":function($event){return _vm.$emit('input', $event)}}},'p-select',_vm.$props,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }